(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat-banner/assets/javascripts/match-progress.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat-banner/assets/javascripts/match-progress.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _svs$components$sport = svs.components.sportinfo.common.matchState,
  SportinfoMatchState = _svs$components$sport.SportinfoMatchState,
  getSportInfoMatchState = _svs$components$sport.getSportInfoMatchState;
const _svs$components$sport2 = svs.components.sportinfo.sportConfig.helpers,
  getStatusText = _svs$components$sport2.getStatusText,
  hasMatchStartSurpassed = _svs$components$sport2.hasMatchStartSurpassed;
const barClassName = {
  [SportinfoMatchState.NotStarted]: 'not-started',
  [SportinfoMatchState.Ongoing]: 'ongoing',
  [SportinfoMatchState.Finished]: 'finished'
};
const StatusText = _ref => {
  let progressText = _ref.progressText;
  if (!progressText) {
    return null;
  }
  if (progressText.formattedTime && progressText.formattedDate) {
    return React.createElement("div", {
      "aria-hidden": true,
      className: "sportinfo_bigstat_header__matchstart"
    }, React.createElement("span", {
      className: "sportinfo_bigstat_header__matchstart_date"
    }, progressText.formattedDate), React.createElement("span", {
      className: "sportinfo_bigstat_header__matchstart_time"
    }, progressText.formattedTime));
  }
  return React.createElement("div", {
    "aria-hidden": true,
    className: "sportinfo_bigstat_header__matchstatus"
  }, progressText.matchStatusText);
};
const MatchProgress = _ref2 => {
  let matchState = _ref2.matchState,
    sportType = _ref2.sportType,
    startTime = _ref2.startTime,
    sportEventStatus = _ref2.sportEventStatus,
    statusTime = _ref2.statusTime;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    setUpdated = _useState2[1];
  const progressText = getStatusText({
    sportEventStatus,
    sportType,
    statusTime,
    matchState,
    matchStart: startTime
  });
  const isNotStarted = matchState === SportinfoMatchState.NotStarted;
  const hasSurpassed = isNotStarted && hasMatchStartSurpassed(sportType, startTime, sportEventStatus);
  useEffect(() => {
    const interval = setInterval(() => {
      setUpdated(Date.now());
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const ariaLabel = useMemo(() => {
    if (isNotStarted) {
      return "Match startar ".concat(progressText === null || progressText === void 0 ? void 0 : progressText.matchStatusText);
    } else if (matchState === SportinfoMatchState.Finished || matchState === SportinfoMatchState.Ended) {
      return "Match avslutad";
    }
    return "Match p\xE5g\xE5r".concat(progressText !== null && progressText !== void 0 && progressText.matchStatusText ? " i minut ".concat(progressText.matchStatusText) : '');
  }, [isNotStarted, matchState, progressText.matchStatusText]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "aria-label": ariaLabel,
    className: "sportinfo_bigstat_header__progress_info"
  }, React.createElement(StatusText, {
    progressText: progressText
  })), React.createElement("div", {
    className: "color-bar ".concat(barClassName[hasSurpassed ? SportinfoMatchState.Finished : getSportInfoMatchState(sportEventStatus)])
  }));
};
setGlobal('svs.components.sportInfo.bigStatBanner.MatchProgress', MatchProgress);

 })(window);